export const initialiseFilterKeyword = (widget: HTMLElement) => {
    const searchInput = widget.querySelector<HTMLInputElement>('.search-filters-widget__filter-search-input')
    if (!searchInput) return
    enableSearchOnEnter(searchInput)
    clearSearchOnInputClear(widget, searchInput)
    addAriaLabelToInput(searchInput)
}

const enableSearchOnEnter = (searchInput: HTMLInputElement) => {
    searchInput.addEventListener('keydown', (event: KeyboardEvent) => {
        if (event.key === 'Enter') {
            event.preventDefault()
            const parentElement = searchInput.closest<HTMLDivElement>('.search-filters-widget__filter-search')
            const searchButton = parentElement?.querySelector<HTMLButtonElement>('.search-filters-widget__filter-search-btn')
            searchButton?.click()
        }
    })
}

const clearSearchOnInputClear = (widget: HTMLElement, searchInput: HTMLInputElement) => {
    const searchButton = widget?.querySelector<HTMLButtonElement>('.search-filters-widget__filter-search-btn')
    if (!searchButton) return

    searchInput.addEventListener('input', () => {
        if (searchInput.value === '') {
            searchButton?.click()
        }
    })
}

const addAriaLabelToInput = (searchInput: HTMLInputElement) => {
    searchInput.setAttribute('aria-label', '{{js.page.jobs.filters.keyword.aria-label}}')
}